import styled from 'styled-components'

function BaseQuickBrowserAddonIcon({ className, size = 18 }: IconComponentProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0763 18.3446C10.433 18.5377 9.68246 18.6343 8.93195 18.6343C5.82268 18.6343 4 16.9929 4 13.9998V4.63443C4.10722 1.64136 5.82268 0 9.03916 0C12.2556 0 13.9711 1.64136 13.9711 4.63443V13.9998C13.9711 15.255 13.6495 16.2205 13.1134 16.9929C13.3278 17.3791 13.7567 17.3791 14.2928 17.3791H14.8288V19.986H13.8639C12.5773 20.0825 11.5051 19.6963 11.0763 18.3446ZM10.6474 14.1929V4.44133C10.6474 3.08962 10.0041 2.60687 8.93195 2.60687C7.85979 2.60687 7.3237 3.08962 7.3237 4.44133V14.1929C7.3237 15.5446 7.967 16.0274 9.03916 16.0274C10.1113 16.0274 10.6474 15.5446 10.6474 14.1929Z"
        fill="#2168D1"
      />
    </svg>
  )
}

export const QuickBrowserAddonIcon = styled(BaseQuickBrowserAddonIcon)``
